module.exports = __webpack_public_path__ + "static/media/eye_square.e8aa65fa.svg";